import { getProblemFromStatus } from 'apisauce'

/**
 * Restore apisauce's status-based `problem` classification.
 *
 * apisauce decides the problem by looking at `error.code` first, and only falls
 * back to the HTTP status when that code is absent. Up to axios 0.21 an error
 * response carried no code, so a 500 became SERVER_ERROR and a 4xx became
 * CLIENT_ERROR. Since axios 0.28 every failed request is an AxiosError tagged
 * with `ERR_BAD_REQUEST` / `ERR_BAD_RESPONSE`, which apisauce does not know
 * about, so everything collapsed into UNKNOWN_ERROR.
 *
 * Only responses that actually carry a status are reclassified: transport
 * failures (timeouts, refused connections, cancellations) have no status and
 * are still classified correctly by apisauce from the error code.
 *
 * @param {Object} api an apisauce instance
 */
export const restoreProblemClassification = (api) => {
    api.addResponseTransform((response) => {
        if (!response.ok && response.status) {
            // apisauce's transform contract is to mutate the response in place
            // eslint-disable-next-line no-param-reassign
            response.problem = getProblemFromStatus(response.status)
        }
    })
    return api
}

export default restoreProblemClassification
